import React from 'react'
import {AlertTitle, Snackbar} from "@mui/material";
import Alert from "@mui/material/Alert";
import {getBottomAlertSx} from "../ui/MuiStyle";
import {useNavigate} from "react-router-dom";

export type Props = {
  onClose: Function,
  spy: string,
}

const SomeOnSpyingYouSnackbar: React.FC<Props> = ({
                                                    onClose, spy
                                                  }) => {
  const navigate = useNavigate();
  return <Snackbar sx={{bottom: '75px!important'}} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} open={true}
                   autoHideDuration={6000} onClose={() => {
    onClose()
  }}>
    <Alert className={"flat-card"} sx={getBottomAlertSx()} severity="error" action={
      <button className={"primary !text-sm"} onClick={() => navigate('/leaderboard/current',{replace:true,state:{openActionDrawer:true}})}>
        HIDE FROM SPIES
      </button>
    }>
      <AlertTitle>Info</AlertTitle>
      <span className={"text-normal"}>{spy} is spying you </span>
    </Alert>
  </Snackbar>
}

export {SomeOnSpyingYouSnackbar};